/**
 * メールの確認まわりの英語の文言（2026-09-28 creator/email-unverified・Core SEC-DEVLOGIN-01 / -08 と (B)）。en.ts が `...enVerify` で取り込む
 * （ja.verify.ts が同じキーを全部持つことを型で強制）。
 *
 * 使う画面: pages/VerifyEmail.tsx（/verify-email）・components/EmailUnverified.tsx（未確認の案内と再送のボタン）・
 * pages/ProjectsPage.tsx（作成で sk_ が出なかったとき）・pages/AccountLoginMethods.tsx（パスワードの無い人はメールのリンク）。
 * WHY 別ファイルか: en.ts が 650 行を超えている。確認の流れ（自動で送らない理由・パスワードの決め直し）の文言をまとめて見直せるように
 */
export const enVerify = {
  // どの画面でも 403 email_unverified を受けたとき（errorText が `error.<code>` を引く）
  'error.email_unverified': 'Check your email address first: open the link in the email {product} sent you.',
  // 連携（ログイン方法の追加）の往復から戻ったとき（OAuthCallback が `oauth.error.<code>` を引く）
  'oauth.error.email_unverified': 'Confirm your email address first, then add {provider}: open the link in the confirmation email {product} sent you.',
  'error.password_reset_required': 'To add a password, use the link we email you.',

  // 未確認の案内（components/EmailUnverified.tsx）
  'emailUnverified.notice':
    'We have not yet checked that the email address {email} is yours. Open the link in the email {product} sent you. Until you do, you cannot make server-only keys (sk_), connect an AI agent, add sign-in methods, set up payouts (payout account, passkeys), add prepaid funds or turn on automatic top-up.',
  // 出金の設定（payouts）を見せない間の同じ文（2026-09-29 creator/launch-money）
  'emailUnverified.noticeLaunch':
    'We have not yet checked that the email address {email} is yours. Open the link in the email {product} sent you. Until you do, you cannot make server-only keys (sk_), connect an AI agent, add sign-in methods, add prepaid funds or turn on automatic top-up.',
  'emailUnverified.resend': 'Send the email again',
  'emailUnverified.sent': 'Sent — check your inbox (and your spam folder if you cannot find it).',
  'projects.secretKeysWithheld':
    'No server-only keys (sk_) yet: you can make them once you open the link in the email we sent you. Then make them on the “Keys (pk_ / sk_)” page, or ask your AI to “set up the keys” (if you type it yourself: {cmd}). The key in your app (pk_) below works already.',

  // /verify-email（pages/VerifyEmail.tsx）
  'verify.confirmLead': 'Press the button to show that this email address is yours, so it can be used for your {product} account.',
  'verify.confirmButton': 'Confirm this email address',
  'verify.otherDeviceNote': 'Opened this on a different device or browser than the one you signed up with? Just in case, you will be asked to choose a new password here.',
  'verify.passwordTitle': 'Choose a new password',
  'verify.passwordLead':
    'If you weren\'t the one who signed up with this email, choose a new password here. Saving it also shows that the email address is yours. Just in case, you were signed out on every other device.',
  'verify.stopNote': "If you stop now, your current password won't work. You can set one later from {link}.",
  'verify.forgotLink': 'Forgot password',
  'verify.expired': 'This page expired (30 minutes). Set a new password from {link} instead.',

  // /account のパスワード（pages/AccountLoginMethods.tsx・パスワードの無い人）
  'login.sendSetLink': 'Email me a link',
  'login.setViaEmail': 'To add a password, we email a link to {email}. Only your inbox can set it.',
  'login.setLinkSent': 'We sent a link to {email}. Open it to set your password (it expires in 30 minutes).'
} as const;
